import request from '@/utils/request'

export function getOrgTree() {
  return request.get(`/hd/group/get_group_list`)
}

// 班级列表
export function getClassesTree() {
  return request.get(`/index/class/list`)
}

export function getRandomQuestion(data) {
  return request({
    url: '/index/question/random_question',
    method: 'get',
    params: data,
  })
}

export function getFolder(data) {
  return request({
    url: '/folder',
    method: 'get',
    params: data,
  })
}